const styles = {
  container: {
    position: 'absolute',
    top: '5vh',
    paddingLeft: '3em',
  },
  separation: {
    display: 'block',
    marginTop: '1em',
    marginBottom: '1em',
  },
  section_pdf: {
    width: '100%',
    height: '500px',
  }
};

export default styles;
